import { Reveal } from "@/components/pdp/reveal";
import { useProduct } from "@/components/pdp/PdpDataContext";

export const EditorialCollage = () => {
  const P = useProduct();
  const { collage } = P;
  const isV31 = !!P.v31;
  return (
    <section className="bg-riversol-blue text-white py-20 lg:py-32" data-testid="editorial-collage" data-inverted-bg="blue">
      <div className="max-w-[1600px] mx-auto px-4 lg:px-8">
        <div className={`grid grid-cols-1 gap-6 items-stretch ${collage.twoBanners ? "lg:grid-cols-3 lg:gap-8" : "lg:grid-cols-12"}`}>
          {/* Copy in negative space */}
          <div className={`flex flex-col justify-center ${collage.twoBanners ? "lg:pr-10" : "lg:col-span-3 lg:pr-4"}`}>
            <div className="pdp-eyebrow font-mono text-[11px] tracking-[0.24em] uppercase text-white/60 mb-6">
              {collage.eyebrow}
            </div>
            <h2
              className={
                isV31
                  ? "font-mono text-3xl md:text-4xl lg:text-5xl mb-8 tracking-tight leading-[1.05]"
                  : "text-3xl md:text-4xl leading-[1.08] tracking-tight font-light mb-6"
              }
            >
              {collage.headline}
            </h2>
            <p
              className={
                isV31
                  ? "text-[16px] lg:text-[17px] leading-[1.75] lg:leading-[1.8] text-white/70"
                  : "text-sm leading-relaxed text-white/70"
              }
            >
              {collage.body}
            </p>
          </div>

          {collage.twoBanners ? (
            <>
              {/* Smaller floating bottle, vertically centered against the banners */}
              <div className="relative aspect-square lg:aspect-auto lg:min-h-0" data-testid="collage-center-image">
                <img
                  src={collage.centerImage}
                  alt={collage.centerAlt}
                  className="w-full h-full object-cover lg:absolute lg:inset-0 lg:p-4"
                  style={{ objectPosition: "28% 50%" }}
                />
              </div>

              {/* Two landscape 16/9 banners, square corners */}
              <div className="flex flex-col gap-6 lg:gap-8">
                <Reveal>
                  <div className="editorial-frame aspect-[16/9] w-full group">
                    <img src={collage.topImage} alt={collage.topAlt} className="w-full h-full object-cover img-zoom" />
                  </div>
                </Reveal>
                <Reveal delay={0.12}>
                  <div className="editorial-frame aspect-[16/9] w-full group">
                    <img src={collage.leftImage} alt={collage.leftAlt} className="w-full h-full object-cover img-zoom" />
                  </div>
                </Reveal>
              </div>
            </>
          ) : (
            <>
              {/* Large central image */}
              <div className="lg:col-span-5">
                <div className="editorial-frame aspect-[10/11] group h-full">
                  <img src={collage.centerImage} alt={collage.centerAlt} className="w-full h-full object-cover img-zoom" />
                </div>
              </div>

              {/* Stacked details, varied scale */}
              <div className="lg:col-span-4 flex flex-col gap-6">
                <Reveal className="flex-1">
                  <div className="editorial-frame h-full group aspect-[16/10]">
                    <img src={collage.topImage} alt={collage.topAlt} className="w-full h-full object-cover img-zoom" />
                  </div>
                </Reveal>
                <div className="grid grid-cols-2 gap-6 flex-1">
                  <Reveal delay={0.1}>
                    <div className="editorial-frame h-full group aspect-square">
                      <img src={collage.leftImage} alt={collage.leftAlt} className="w-full h-full object-cover img-zoom" />
                    </div>
                  </Reveal>
                  <Reveal delay={0.2}>
                    <div className="editorial-frame h-full group aspect-square">
                      <img src={collage.rightImage} alt={collage.rightAlt} className="w-full h-full object-cover img-zoom" />
                    </div>
                  </Reveal>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default EditorialCollage;
